import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';

function getRiseTip(riseInfo) {
  if (!isEmpty(riseInfo)) {
    const {
      RZDF, FEATURE, linkZSB, SYL_Z,
    } = riseInfo;

    if (linkZSB === '1') {
      // 指数 7天
      if ((FEATURE.indexOf('050') !== -1 || FEATURE.indexOf('318') !== -1)) {
        if (Math.abs(parseFloat(SYL_Z)) > 5.0) {
          return `周涨幅${parseFloat(SYL_Z).toFixed(2)}%，来看看涨跌分析`;
        }
      }
    }

    // 日涨幅
    if (Math.abs(parseFloat(RZDF)) > 3.0) {
      return `日涨幅${parseFloat(RZDF).toFixed(2)}%，来看看涨跌分析`;
    }
  }
  return '';
}

function getMoreList(bottomMoreInfo, wealthData) {
  // 条件单
  const conditionalSheetInfo = {
    title: '条件单',
    image: bottomMoreInfo?.isSupportConditionalSheet
      ? 'https://j5.dfcfw.com/sc/image/202303/20230306053836.png'
      : 'https://j5.dfcfw.com/sc/image/202303/20230306052057.png',
    clickEvent: () => {},
  };

  // 定投计算器
  const fixedInvestCaculatorInfo = {
    title: '定投计算器',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322881.png',
    clickEvent: () => {},
  };

  // 诊断
  const diagnoseInfo = {
    title: '诊断',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322869.png',
    clickEvent: () => {},
  };

  // 提醒
  const remindInfo = {
    title: '提醒',
    image: 'https://j5.dfcfw.com/sc/image/202212/20221220063046.png',
    clickEvent: () => {},
  };

  // 财富号
  const bottomWealthInfo = wealthData?.bottomWealthInfo || {};
  const cfhInfo = {
    title: '财富号',
    image: bottomWealthInfo?.image || 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322861.png',
    clickEvent: () => {},
    tipText: bottomWealthInfo?.tipText || '',
    guideText: bottomWealthInfo?.guideText || '',
  };

  // 机构解读
  const agencyAnalyseInfo = {
    title: '机构解读',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322877.png',
    clickEvent: () => {},
  };

  // 提问
  const askQuestionInfo = {
    title: '提问',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322871.png',
    clickEvent: () => {},
  };

  // 发帖
  const postInfo = {
    title: '发帖',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322825.png',
    clickEvent: () => {},
  };

  // 备注
  const remarksInfo = {
    title: '备注',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1639127552448.png',
    clickEvent: () => {},
  };

  // 智能助理
  const smartAssistantInfo = {
    title: '智能助理',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322872.png',
    clickEvent: () => {},
    tipText: getRiseTip(bottomMoreInfo) ? '涨跌分析' : '',
    guideText: getRiseTip(bottomMoreInfo),
  };

  // 分享
  const fundShareInfo = {
    title: '分享',
    image: 'https://j5.dfcfw.com/imagesystem/material_imgs/1634699322826.png',
    clickEvent: () => {},
  };

  const result = [
    conditionalSheetInfo,
    fixedInvestCaculatorInfo,
    diagnoseInfo,
    remindInfo,
    cfhInfo,
    agencyAnalyseInfo,
    askQuestionInfo,
    postInfo,
    remarksInfo,
    smartAssistantInfo,
    fundShareInfo,
  ];

  return result;
}

export default {
  getMoreList,
};
